export default "__VITE_ASSET__5hQh5Cey__"